import React, { useEffect, useState } from 'react';
import { useMessage } from '../../hooks/useMessage';
import { BackendPayload, FormsProps } from '../../types/forms';
import { getDecisionCriteria } from '../../api/decisions.api';
import { getFormsResult, submitForm } from '../../api/forms.api';
import { transformFormFields } from '../../utils/forms.utils';
import Loading from '../loading/Loading';
import { Typography } from '@mui/material';
import DynamicForm from '../DynamicForm/DynamicForm';

const DataUpdateForm = ({ formId, responseId, onCancel, onAfterUpdate }: FormsProps) => {
    const { showMessage, MessageContainer } = useMessage();
    const [ loading, setLoading ] = useState(true);
    const [ submitting, setSubmitting ] = useState(false);
    const [ formAllFields, setFormAllFields ] = React.useState<BackendPayload['fields']>([]);

    useEffect(() => {
        if (!formId || !responseId) {
            setLoading(false);
            return;
        }

        Promise.all([
            getDecisionCriteria(formId),
            getFormsResult(formId, responseId),
        ])
               .then(results => {
                   const [ response, response2 ] = results;

                   const values: {
                       [key: string]: any
                   } = {};
                   response2.response.forEach(item => {
                       values[item.id] = item.value;
                   });

                   const elements: any[] = response.form_config.elements;
                   const formattedElements: BackendPayload['fields'] = [];
                   elements.forEach(element => {
                       formattedElements.push(...transformFormFields(element.children, values));
                   });
                   setFormAllFields(formattedElements);
               })
               .catch((e) => {
                   // TODO show error message
                   console.log([ e ]);
               })
               .finally(() => setLoading(false));
    }, [ formId, responseId ]);

    const submitFormHandler = async (values: {
        [key: string]: any
    }) => {
        if (!formId || !responseId) {
            return;
        }

        const formData: {
            form_id: number;
            response_id: number;
            data: {
                id: string;
                value: any;
            }[];
        } = {
            form_id: +formId,
            response_id: +responseId,
            data: [],
        };

        Object.keys(values).forEach((key: string) => {
            formData.data.push({ id: key, value: values[key] });
        });

        setSubmitting(true);
        submitForm(formData)
        .then(() => {
            setSubmitting(false);
            showMessage('You response was updated successfully.', 'success');
            onAfterUpdate?.(formData);
            onCancel && setTimeout(onCancel, 1500);
        })
        .finally(() => setSubmitting(false));
    };

    return (
        <div>
            {loading ? <Loading/> : (
                <div style={{ width: 500, margin: '32px auto' }}>
                    <div>
                        <Typography variant="h4" gutterBottom>Edit result {responseId}</Typography>
                    </div>
                    <DynamicForm
                        config={{ fields: formAllFields.filter(item => !item.hidden) }}
                        onSubmit={submitFormHandler}
                        apiSubmitting={submitting}
                        saveButtonLabel="Save"
                        hasCancelButton
                        onCancel={onCancel}
                    />
                </div>
            )}
            <MessageContainer/>
        </div>
    );
};

export default DataUpdateForm;